// Mutations
import { RESET_MODULE } from '@/store/mutation-types'

// Default state
const getDefaultState = () => {
  return {
    filters: {}
  }
}
const state = getDefaultState()

// -----------------------------------------------------------------------------

const mutations = {
  setFilters (state, filters) {
    state.filters = filters
  },

  [RESET_MODULE] (state) {
    Object.assign(state, getDefaultState())
  }
}

export default () => ({
  namespaced: true,
  state,
  mutations
})
